import { BaseDto } from "@/shared/dtos/base-dto";

export class ayuntamiento extends BaseDto {
  public nombre!: string;
  public pos_mapa!:string;
  public id_provincia!:number;
}
